<div
    class="side-menu-parent"
    [class.side-menu-parent--active]="active"
    [class.side-menu-parent--is-child]="!!parentId"
>
    <div class="side-menu-parent__label">
        {{ label }}
        @if (badge && badge.value) {
            <nw-pill
                class="side-menu-parent__label__pill"
                [nwAddAttributes]="badge.attributes"
                >{{ badge.value }}</nw-pill
            >
        }
    </div>
    <nw-icon
        class="side-menu-parent__chevron"
        [class.side-menu-parent__chevron--active]="open"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill
            viewBox="0 0 22 13"
            height="100%"
            width="100%"
            style="display: block"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
        >
            <path
                fill="currentColor"
                d="M9.94 12.06a1.502 1.502 0 0 0 2.124 0l9-9A1.502 1.502 0 0 0 18.941.935L11 8.876 3.058.942A1.502 1.502 0 0 0 .936 3.064l9 9 .005-.005Z"
            />
        </svg>
    </nw-icon>
</div>
